import { MdFastfood } from "react-icons/md";
import { FiMonitor } from "react-icons/fi";
import { FaCakeCandles } from "react-icons/fa6";
import { GiFlowerEmblem } from "react-icons/gi";

import {
  Card,
  Icon,
  LeftSection,
  PrivateTheatreCont,
  RightSection,
} from "./PrivateTheatreContainer.styles";

const PrivateTheatreContainer = () => {
  const cardData = [
    {
      icon: <MdFastfood />,
      title: "Food & Beverages",
      description:
        "Enjoy delicious in-theatre dining options at affordable prices!",
    },
    {
      icon: <FiMonitor />,
      title: "Screening",
      description: "Bring your own OTT accounts and relive theatre magic!.",
    },
    {
      icon: <FaCakeCandles />,
      title: "Cakes",
      description:
        "Discover your ideal celebration cake from our diverse selection.",
    },
    {
      icon: <GiFlowerEmblem />,
      title: "Bouquets",
      description:
        "Elevate your celebration with a stunning rose bouquet addition.",
    },
  ];
  return (
    <PrivateTheatreCont>
      <LeftSection>
        <p className="text">Private Theatre Celebrations</p>
      </LeftSection>

      <RightSection>
        {cardData.map((card, index) => (
          <Card key={index}>
            <div style={{ width: "70px" }}>
              <Icon>{card.icon}</Icon>
            </div>
            <div>
              <p className="title">{card.title}</p>
              <p className="desc">{card.description}</p>
            </div>
          </Card>
        ))}
      </RightSection>
    </PrivateTheatreCont>
  );
};

export default PrivateTheatreContainer;
